import { HTMLAttributes } from "react";
import { To, useNavigate } from "react-router-dom";
import classNames from "classnames";

interface BackButtonProps extends HTMLAttributes<HTMLDivElement> {
  to?: To;
  text?: string;
  compact?: boolean;
}

export const BackButton = ({ to, text = "Back", compact = false, className, ...otherProps }: BackButtonProps) => {
  const navigate = useNavigate();

  return (
    <div
      role="button"
      onClick={() => navigate(to ? to : (-1 as To))}
      className={classNames(
        "flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 transition-all duration-200 hover:opacity-80",
        {
          "shadow-[0px_0px_32px_-8px_rgba(165,44,161,0.12)]": compact,
          "md:h-[43px] md:w-fit md:justify-start md:gap-[9px] md:rounded-[14px] md:bg-[#f5f5f5] md:p-3": !compact,
        },
        className,
      )}
      {...otherProps}
    >
      <div
        className={classNames(
          "flex h-6 w-6 items-center justify-center rounded-full border-[1.5px] border-solid border-current",
          {
            "md:h-auto md:w-auto md:rounded-none md:border-none": !compact,
          },
        )}
      >
        <svg
          className="scale-80 md:scale-100"
          width="10"
          height="15"
          viewBox="0 0 10 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.90625 7.35938C0.914062 6.96875 1.04688 6.64844 1.36719 6.34375L7.27344 0.554688C7.51562 0.320312 7.79688 0.203125 8.14062 0.203125C8.82812 0.203125 9.39844 0.765625 9.39844 1.44531C9.39844 1.78906 9.25 2.10938 8.99219 2.35938L3.84375 7.35156L8.99219 12.3516C9.25 12.6094 9.39844 12.9219 9.39844 13.2734C9.39844 13.9609 8.82812 14.5156 8.14062 14.5156C7.79688 14.5156 7.51562 14.3984 7.27344 14.1641L1.36719 8.375C1.04688 8.0625 0.90625 7.74219 0.90625 7.35938Z"
            fill="#1E1E1E"
          />
        </svg>
      </div>
      {!compact && (
        <div className="font-helvetica-neue text-eerie-black hidden text-[16px] leading-[1.2] font-bold tracking-[-0.02em] whitespace-nowrap md:block">
          {text}
        </div>
      )}
    </div>
  );
};
